"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbLoader = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SbLoader = /*#__PURE__*/function (_Component) {
  _inherits(SbLoader, _Component);

  var _super = _createSuper(SbLoader);

  function SbLoader(props) {
    var _this;

    _classCallCheck(this, SbLoader);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "showSpinnerAfterDelay", function () {
      _this.setState({
        delayFinished: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getComponentStyle", function () {
      var _this$props = _this.props,
          size = _this$props.size,
          style = _this$props.style;
      var componentStyle = typeof size === 'number' ? {
        width: "".concat(size, "px"),
        height: "".concat(size, "px"),
        fontSize: "".concat(size, "px")
      } : {};
      return _objectSpread(_objectSpread({}, style), componentStyle);
    });

    _defineProperty(_assertThisInitialized(_this), "wrapLoader", function (loader) {
      var _this$props2 = _this.props,
          containerClassName = _this$props2.containerClassName,
          type = _this$props2.type,
          containerId = _this$props2.containerId,
          containerStyle = _this$props2.containerStyle;

      var component = _this.renderTextToLoader(loader);

      if (type === _constants.loaderType.OVERLAY) {
        var componentContainerClassName = (0, _classnames.default)({
          'sb-loader-container': true
        }, containerClassName);
        return /*#__PURE__*/_react.default.createElement("div", {
          className: componentContainerClassName,
          id: containerId,
          style: containerStyle
        }, component);
      }

      return component;
    });

    _defineProperty(_assertThisInitialized(_this), "renderTextToLoader", function (loader) {
      var _this$props3 = _this.props,
          loadingText = _this$props3.loadingText,
          textWrapperId = _this$props3.textWrapperId,
          textWrapperStyle = _this$props3.textWrapperStyle,
          textWrapperClassName = _this$props3.textWrapperClassName;

      if (loadingText) {
        var componentTextWrapperClassName = (0, _classnames.default)({
          'sb-loader-wrapper-with-text': true
        }, textWrapperClassName);
        return /*#__PURE__*/_react.default.createElement("div", {
          className: componentTextWrapperClassName,
          id: textWrapperId,
          style: textWrapperStyle
        }, loader, /*#__PURE__*/_react.default.createElement("div", {
          className: "sb-loader-text"
        }, loadingText));
      }

      return loader;
    });

    var show = props.show,
        showDelay = props.showDelay;
    _this.state = {
      delayFinished: showDelay <= 0
    };

    if (show && showDelay > 0) {
      _this.debounceShow = setTimeout(_this.showSpinnerAfterDelay, showDelay);
    }

    return _this;
  }

  _createClass(SbLoader, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.debounceShow);
    }
  }, {
    key: "render",
    value: function render() {
      var delayFinished = this.state.delayFinished;
      var _this$props4 = this.props,
          id = _this$props4.id,
          size = _this$props4.size,
          show = _this$props4.show,
          className = _this$props4.className;
      var componentClassName = (0, _classnames.default)(_objectSpread({
        'sb-loader': true
      }, typeof size === 'string' ? _defineProperty({}, "sb-loader-".concat(size), true) : {}), className);
      return show && delayFinished && this.wrapLoader( /*#__PURE__*/_react.default.createElement("div", {
        className: componentClassName,
        id: id,
        style: this.getComponentStyle(),
        role: "progressbar"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "sbi-loader"
      })));
    }
  }]);

  return SbLoader;
}(_react.Component);

exports.SbLoader = SbLoader;
SbLoader.propTypes = {
  className: _propTypes.default.string,
  containerClassName: _propTypes.default.string,
  containerId: _propTypes.default.string,
  containerStyle: _propTypes.default.object,
  // eslint-disable-line
  id: _propTypes.default.string,
  loadingText: _propTypes.default.string,
  show: _propTypes.default.bool,
  showDelay: _propTypes.default.number,
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf([_constants.loaderSize.XXS, _constants.loaderSize.XS, _constants.loaderSize.SM, _constants.loaderSize.S, _constants.loaderSize.M, _constants.loaderSize.ML, _constants.loaderSize.L]), _propTypes.default.number]),
  style: _propTypes.default.object,
  // eslint-disable-line
  textWrapperClassName: _propTypes.default.string,
  textWrapperId: _propTypes.default.string,
  textWrapperStyle: _propTypes.default.object,
  // eslint-disable-line
  type: _propTypes.default.string
};
SbLoader.defaultProps = {
  className: null,
  containerClassName: null,
  containerId: null,
  containerStyle: {},
  id: null,
  loadingText: null,
  show: false,
  showDelay: 0,
  size: _constants.loaderSize.XXS,
  style: {},
  textWrapperClassName: null,
  textWrapperId: null,
  textWrapperStyle: {},
  type: _constants.loaderType.SIMPLE
};
//# sourceMappingURL=sb-loader.js.map